import request from '@request'

/** 查询账户信息 */
export function getEarnUser() {
  return request.$get('/earn/api/account')
}

/** 查询配置信息 */
export function getEarnConfig() {
  return request.$get('/earn/api/config')
}

/** 查询账户利息记录 */
export function postEarnInterestRecord(params) {
  return request.$post('/earn/api/interest/record',params)
}

/** 账户利息转入转出 */
export function postEarnTrade(params) {
  return request.$post('/earn/api/trade',params)
}